<ng-container *cbWaitFor="lotMappedItem$$ | async">
    @if (!selectedItem) {
        <cb-design-concept-search
            (designConceptSelected)="designConceptSelected($event)"
            [lotId]="lotMappedItem.id"
        >
        </cb-design-concept-search>
    }
    @if (selectedItem) {
        <cb-design-concept
            [(designConcept)]="selectedItem"
            (designConceptChange)="cdRef.detectChanges()"
            (lotMappedItemChange)="lotMappedItemChanged()"
            (backToSearch)="goBackToSearch()"
            [lot]="lotMappedItem"
        >
        </cb-design-concept>
    }
</ng-container>
